import { render, staticRenderFns } from "./centerLoader.vue?vue&type=template&id=3584ef1f&scoped=true&"
var script = {}
import style0 from "./centerLoader.vue?vue&type=style&index=0&id=3584ef1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3584ef1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3584ef1f')) {
      api.createRecord('3584ef1f', component.options)
    } else {
      api.reload('3584ef1f', component.options)
    }
    module.hot.accept("./centerLoader.vue?vue&type=template&id=3584ef1f&scoped=true&", function () {
      api.rerender('3584ef1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/general/centerLoader.vue"
export default component.exports